import { Subject } from "rxjs";

const ControlPassSubject = new Subject();

export { ControlPassSubject };



// WEBPACK FOOTER //
// ./src/shared/ControlPassSubject.js